import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Layers } from "lucide-react";
import {
  PrintLayoutForm,
  type PrintLayoutFormProps,
  type PrintLayoutFormSuccessResult,
} from "./PrintLayoutForm";

export interface PrintLayoutModalContainerProps
  extends Omit<PrintLayoutFormProps, "isDrawerMode" | "onCancel" | "onSuccess"> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  stackLevel?: number;
  title?: string;
  onSuccess?: (result: PrintLayoutFormSuccessResult) => void | Promise<void>;
}

/**
 * PrintLayoutModalContainer — Rule 2.2 Presentation Container ONLY.
 * Bọc Canonical PrintLayoutForm với isDrawerMode={true} (vô hiệu hóa Top Header Portal theo Rule 3.2).
 */
export function PrintLayoutModalContainer({
  open,
  onOpenChange,
  stackLevel = 0,
  title,
  mode = "create",
  layoutId = null,
  initialDetails = [],
  orderId = null,
  orderCode = null,
  focusField = null,
  onSuccess,
}: PrintLayoutModalContainerProps) {
  const computedZ = 50 + stackLevel * 10;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        style={{ zIndex: computedZ }}
        className="max-w-[96vw] xl:max-w-6xl max-h-[92vh] overflow-y-auto p-4 sm:p-5 bg-slate-50/95"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Layers className="h-4 w-4 text-indigo-600 shrink-0" />
            <span>
              {title ||
                (mode === "edit" || layoutId
                  ? "Chỉnh sửa Bài Bình File"
                  : initialDetails.length > 1
                    ? `Bình File / Ghép Bài (${initialDetails.length} sản phẩm)`
                    : "Bình File Sản Xuất")}
            </span>
          </DialogTitle>
          <DialogDescription className="text-xs text-slate-500">
            Cập nhật mã bài bình, khổ giấy in, số Ups, số lượng tờ in mỗi Ups và ảnh sơ đồ bài bình.
          </DialogDescription>
        </DialogHeader>

        {open && (
          <PrintLayoutForm
            mode={mode}
            layoutId={layoutId}
            initialDetails={initialDetails}
            orderId={orderId}
            orderCode={orderCode}
            focusField={focusField}
            isDrawerMode
            onCancel={() => onOpenChange(false)}
            onSuccess={async (res) => {
              await onSuccess?.(res);
              onOpenChange(false);
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

export default PrintLayoutModalContainer;
